import { createEntityThunks } from './dataThunks';
import {
  VaccineService,
  PatientService,
  AppointmentService,
  RecordService,
  CenterService,
  StockService,
  PlanService,
  MedicalStaffService,
  UserService,
  SupplierService,
  DistrictService,
  TalukaService,
  VillageService,
  VaccineDispatchService,
} from '../../../shared/services';

// Create thunks for all entities
export const vaccineThunks = createEntityThunks('vaccines', VaccineService);
export const patientThunks = createEntityThunks('patients', PatientService);
export const appointmentThunks = createEntityThunks('appointments', AppointmentService);
export const recordThunks = createEntityThunks('record', RecordService);
export const centerThunks = createEntityThunks('centers', CenterService);
export const stockThunks = createEntityThunks('stock', StockService);
export const planThunks = createEntityThunks('plan', PlanService);
export const medicalStaffThunks = createEntityThunks('medicalStaff', MedicalStaffService);
export const userThunks = createEntityThunks('users', UserService);
export const supplierThunks = createEntityThunks('suppliers', SupplierService);
export const districtThunks = createEntityThunks('districts', DistrictService);
export const talukaThunks = createEntityThunks('talukas', TalukaService);
export const villageThunks = createEntityThunks('villages', VillageService);
export const vaccineDispatchThunks = createEntityThunks('vaccineDispatch', VaccineDispatchService);

// Entity thunks map for dynamic access
export const entityThunksMap = {
  vaccines: vaccineThunks,
  patients: patientThunks,
  appointments: appointmentThunks,
  record: recordThunks,
  record: recordThunks,
  centers: centerThunks,
  stock: stockThunks,
  plan: planThunks,
  medicalStaff: medicalStaffThunks,
  users: userThunks,
  suppliers: supplierThunks,
  districts: districtThunks,
  talukas: talukaThunks,
  villages: villageThunks,
  vaccineDispatch: vaccineDispatchThunks,
};

// Helper to get thunks by entity name
export const getEntityThunks = (entityName) => {
  return entityThunksMap[entityName] || null;
};
